export enum StatusCdo {
  DISABLED = 1,
  PENDING = 2,
  ENABLED = 3
}